














































import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import BaseComponent from '@/components/base/BaseComponent';
import { EmployerDetails } from '@/models/form/EmployerDetails.model';
import { EMPLOYER_DETAILS, FORM101_DATA, FORM_READ_ONLY_MODE } from '@/types/form.types';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { Form101DataModel } from '@/models/form/Form101Data.model';

@Component({})
export default class EmployerDetailsStep extends BaseComponent {
  @Getter(EMPLOYER_DETAILS, StoreNamespace.FORM) public employerDetails!: EmployerDetails;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;

  private noEmployerDetails: boolean = false;

  public created() {
    if (!this.employerDetails.employerDeductionNumber && !this.formReadOnlyMode) {
      this.noEmployerDetails = true;
    }
  }

  public closeDialog() {
    this.noEmployerDetails = false;
    this.$router.push({ name: 'lobby' });
  }

}
